import { operationalTeamApiUrls } from 'constants/apiEndPoints';
import { type SupportTeamEmployeeType, type CreateComplaintForSupportType } from 'types/services';
import apiUtils from "utils/ApiUtil";
// /
const getAllSupportEmployeeList = async (): Promise<SupportTeamEmployeeType[]> => {
    return await apiUtils.getWithToken(operationalTeamApiUrls.getAllSupportEmployeeListUrl) as SupportTeamEmployeeType[];

};

const createComplatintForSupport = async (data: CreateComplaintForSupportType): Promise<CreateComplaintForSupportType[]> => {
    return await apiUtils.postWithToken(operationalTeamApiUrls.createComplatintForSupportUrl, data) as CreateComplaintForSupportType[];

};
export { getAllSupportEmployeeList, createComplatintForSupport }